import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
// Widened to include 'youtube'/'x' — these channels already exist in
// channel_secrets/connected_accounts (see packages/db/src/provision.ts) and
// apps/web/src/pages/admin/channels-types.ts's ChannelProviderName; this
// enum had drifted behind them.
export const ChannelEnum = z.enum([
    'email',
    'sms',
    'whatsapp',
    'facebook',
    'instagram',
    'chat',
    'youtube',
    'x',
    'telegram',
]);
export const ChannelDeliveryReceiptEventSchema = z.object({
    type: z.literal('channel.delivery.receipt'),
    ...baseEventFields,
    channel: ChannelEnum,
    provider: z.string().min(1),
    providerMessageId: z.string().min(1),
    eventType: z.enum(['delivered', 'read', 'failed', 'bounced']),
    providerErrorCode: z.string().nullable().optional(),
    recipientHandle: z.string().nullable().optional(),
    rawPayload: z.record(z.unknown()),
});
export const ConversationMessageStatusChangedEventSchema = z.object({
    type: z.literal('conversation.message.status.changed'),
    ...baseEventFields,
    conversationId: uuidSchema,
    messageId: uuidSchema,
    status: z.enum(['sent', 'delivered', 'read', 'failed', 'bounced']),
    providerErrorCode: z.string().nullable().optional(),
});
export const ChatListBumpEventSchema = z.object({
    tenantSlug: z.string(),
    channel: z.string(),
    conversationId: z.string(),
});
//# sourceMappingURL=channel.js.map